import m from "mithril";

import {
	defineWidget,
	ButtonNew,
	CardieWidget,
	InputWidget,
	Notification,
	NoticeWidget
} from "@nebularstreams/libmui"

const
	ValidateStreamName = (orga, streamname) => {
		return streamname.length === 11 && streamname.startsWith(`${orga}-`)
	},
	ChangeStreamName = (attrs, streamname) => {
		if (ValidateStreamName(attrs.orga, streamname)) {
			m.route.set(`/${attrs.orga}/${attrs.service}/${streamname}`)
		} else {
			Notification.add(`Invalid Stream Name, must begin with ${attrs.orga}-`);
		}
	},

	StreamCard = defineWidget(
		({attrs, state}) => m(CardieWidget,
			{
				class: "streamcard " + (attrs.class || ""),
				nofold: true,
				element: "div"
			},

			// first card
			attrs.state.streamname
				? [
					m(".streamname.fixstreamname", attrs.state.streamname),

					m(".grows"),
					m(ButtonNew, {
						class: "orangebutton",
						icon: "sync",
						text: "change stream",
						onClick: () => {
							delete attrs.state.streamname;
							delete attrs.state.replayStreamname;
							delete attrs.state.currentItem;
							attrs.state.content = {};
							m.route.set(`/${attrs.orga}/${attrs.service}`)
						}
					})
				]
				: [
					m(InputWidget, {
						label: "Stream Name",
						value: attrs.state.streamname,
						hint: attrs.orga ? attrs.orga + "-xxxxx" : "Enter a streamname",
						maxlength: 11,
						class: state.isValid ? "valid" : "invalid",
						oninput: (value) => {
							state.isValid = ValidateStreamName(attrs.orga, value);
							m.redraw();
						},
						onchange: (streamname) => ChangeStreamName(attrs, streamname, false)
					}),

					...attrs.state.help ? [
						m(NoticeWidget, {
							icon: "info-circle",
							text: attrs.state.help,
							class: "help noselect"
						})
					] : []
				]
		),
	);

export {StreamCard, ValidateStreamName}
